
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/category/[categorySlug]",
      function () {
        return require("private-next-pages/shop/category/[categorySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/category/[categorySlug]"])
      });
    }
  